(function ($) {
  DJ.addBehavior('relatedSlider', '.related__slider', {
    attach: function () {
      const slider = this;
      const $slider = $(slider);
      const svgPath = DJ.getDrupalSettings().isSlicingEnvironment
        ? '../../assets/sprites/symbol/svg/sprite.symbol.svg'
        : '/themes/custom/cems_front/public/assets/sprites/symbol/svg/sprite.symbol.svg';
      let currentBreakpoint = DJ.bp.name;

      /**
       * Set equal height for blocks inside slides.
       */
      const setEqualHeight = () => {
        let maxHeight = -1;
        const elements = this.querySelectorAll('.short-info');

        elements.forEach((e) => {
          maxHeight = Math.max(maxHeight, e.offsetHeight);
        });

        elements.forEach((e) => {
          e.style.height = `${maxHeight}px`;
        });
      };

      /**
       * Build slider.
       */
      const buildSlider = () => {
        if (!slider.getAttribute('data-slider-init')) {
          setEqualHeight();

          $slider.slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: true,
            prevArrow: `<button type="button" class="slick-prev">
                        <span class="svg-icon"><svg><use xlink:href="${svgPath}#arrow"></use></svg></span>
                      </button>`,
            nextArrow: `<button type="button" class="slick-next">
                        <span class="svg-icon"><svg><use xlink:href="${svgPath}#arrow"></use></svg></span>
                      </button>`,
            useCSS: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
              }
            ]
          });

          slider.setAttribute('data-slider-init', 'true');
        }
      };

      /**
       * Destroy slider (if it's initialized).
       */
      const destroySlider = () => {
        if (slider.getAttribute('data-slider-init')) {
          $slider.slick('unslick');
          slider.removeAttribute('data-slider-init');
        }
      };

      /**
       * Init slider only if mobile version.
       */
      const checkSlider = () => {
        if (DJ.bp.name === 'tablet' || DJ.bp.name === 'mobile') {
          buildSlider();
        } else {
          destroySlider();
        }
      };

      /**
       * init/destroy slider depends on window size(desktop/mobile).
       */
      DJ.on('changeBreakpoint', function (e) {
        setTimeout(function () {
          if (currentBreakpoint !== DJ.bp.name) {
            checkSlider();
            currentBreakpoint = DJ.bp.name;
          }
        }, 500);
      });

      checkSlider();
    }
  });
})(jQuery);
